import{useInjection as o}from"inversify-react";import{INVERSIFY_TYPES as i}from"../../inversify/index.js";const p=()=>o(i.api);export{p as useApi};
